// extracted by mini-css-extract-plugin
export default {"tableBox":"install-wizard_tableBox__uPRSq","table":"install-wizard_table__PDc+V","th":"install-wizard_th__VoM3f","tr":"install-wizard_tr__DzXcC"};